import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

interface RangeSilderProps {
    min: number;
    max: number;
    step: number;
    value: number | number[];
    handleChange: (event: Event, value: number | number[]) => void;
}

const StyledSlider = styled(Slider)(({ theme }) => ({
    height: 2,

    "& .MuiSlider-rail": {
        color: "#E0E0E0",
    },

    "& .MuiSlider-thumb": {
        width: "12px",
        height: "12px",
        color: "var(--color-brand)",
    },
    "& .MuiSlider-track": {
        border: "none",
        color: "var(--color-brand)",
    },
}));

const RangeSilder = ({
    min,
    max,
    step,
    handleChange,
    value,
}: RangeSilderProps) => {
    return (
        <StyledSlider
            aria-labelledby="track-false-range-slider"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={handleChange}
        />
    );
};

export default RangeSilder;